<template>
  <b-modal
    ref="modal-ruangan"
    v-model="showModal"
    centered
    :title="`${propsModal.modal.action} Form Ruangan`"
    size="lg"
    no-close-on-backdrop
  >
    <b-form>
      <b-form-group
        label="Lantai"
        label-class="pb-0 pt-0"
        label-for="lantai"
      >
        <b-form-select
          v-model="v$.formRuangan.lantai.$model"
          :options="options.lantai"
          :state="validateState(v$.formRuangan.lantai)"
        />
        <b-form-invalid-feedback
          v-for="(error, index) of v$.formRuangan.lantai.$errors"
          :key="index"
        >
          {{ error.$message }}
        </b-form-invalid-feedback>
      </b-form-group>
      <label
        for="kodeRuangan"
        class="d-block pb-0 pt-0"
      >
        Jenis Ruangan
        <feather-icon
          v-b-tooltip.hover
          icon="AlertCircleIcon"
          class="text-warning"
          title="Jika jenis ruangan tidak tersedia pada pilihan, maka dapat bermohon untuk penambahan jenis ruangan kepada BPAD"
        />
      </label>
      <v-select
        id="jenisRuangan"
        v-model="v$.formRuangan.jenisRuangan.$model"
        :options="options.jenisRuangan"
        label="text"
      />
      <small
        v-for="(error, index) of v$.formRuangan.jenisRuangan.$errors"
        :key="index"
        class="text-danger"
      >
        {{ error.$message }}
      </small>
      <b-form-group
        label="Nama Ruangan"
        label-class="pb-0 mt-1"
        label-for="namaRuangan"
      >
        <b-form-input
          v-model="v$.formRuangan.namaRuangan.$model"
          :state="validateState(v$.formRuangan.namaRuangan)"
        />
        <b-form-invalid-feedback
          v-for="(error, index) of v$.formRuangan.namaRuangan.$errors"
          :key="index"
        >
          {{ error.$message }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
    <template #modal-footer>
      <div>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          :disabled="formRuangan.isSubmit"
          @click="submitForm"
        >
          <div v-if="formRuangan.isSubmit">
            <b-spinner small />
            <span class="sr-only">Loading...</span>
          </div>
          <div v-else>
            Simpan
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import {
  ref, computed, watchEffect, watch,
} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { required, helpers } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import vSelect from 'vue-select'
import helper from '@/libs/helper'
import { propsObject } from '@/utils/propsTipeData'
import apiLantai from '@/composables/master/lantai'
import apiJenisRuangan from '@/composables/master/jenisRuangan'
import apiRuangan from '@/composables/b/ruangan'

export default {
  setup(props, context) {
    const g = context.root
    const { validateState, requiredMessage, defaultValue } = helper

    const showModal = ref(false)
    const toggleModal = ref(null)
    const formRuangan = ref({
      lantai: null,
      jenisRuangan: defaultValue,
      namaRuangan: '',
      isSubmit: false,
    })
    const tempRuangan = ref({})
    const tempOptions = ref({})

    const options = ref({
      lantai: [defaultValue],
      jenisRuangan: [defaultValue],
    })

    watchEffect(() => {
      toggleModal.value = props.propsModal.modal.toggleModal
      tempRuangan.value = props.propsModal.ruangan
      tempOptions.value.lantai = props.propsModal.lantaiOptions
    })

    watch(toggleModal, () => {
      showModal.value = true
    })

    watch(tempRuangan, () => {
      formRuangan.value.lantai = tempRuangan.value.lantai
      formRuangan.value.jenisRuangan = tempRuangan.value.jenisRuangan
      formRuangan.value.namaRuangan = tempRuangan.value.namaRuangan
    })

    watch(tempOptions, () => {
      options.value.lantai = tempOptions.value.lantai
    })

    const requiredMsg = requiredMessage
    const customRequiredObject = fieldName => ({
      checkField: helpers.withMessage(
        `${fieldName} ${requiredMsg}`,
        val => !!val.value,
      ),
    })

    const commonValidateRequired = fieldName => ({
      required: helpers.withMessage(
        `${fieldName} ${requiredMsg}`,
        required,
      ),
    })

    const $externalResults = ref({})
    const rules = computed(() => ({
      formRuangan: {
        lantai: commonValidateRequired('Lantai'),
        jenisRuangan: customRequiredObject('Jenis ruangan'),
        namaRuangan: commonValidateRequired('Nama ruangan'),
      },
    }))

    const fieldForm = { formRuangan }

    const v$ = useVuelidate(
      rules,
      fieldForm,
      { $externalResults, $autoDirty: true },
    )

    const getLantai = () => apiLantai.getLantai(g)

    const getJenisRuangan = () => {
      const params = {
        limit: 1000000,
      }
      return apiJenisRuangan.getData(g, params)
    }

    const initData = async () => {
      if (options.value.lantai.length < 2) {
        const resultLantai = await getLantai()
        options.value.lantai = [helper.defaultValue, ...resultLantai.rows]
      }

      const resultJenisRuangan = await getJenisRuangan()
      options.value.jenisRuangan = [helper.defaultValue, ...resultJenisRuangan.rows.map(item => ({ text: item.jenis_ruangan, value: item.id }))]
    }
    initData()

    const submitForm = async () => {
      formRuangan.value.isSubmit = true

      const isFormCorrect = await v$.value.$validate()
      // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
      if (!isFormCorrect) {
        console.log(v$.value)
        formRuangan.value.isSubmit = false
        return
      }

      try {
        if (props.propsModal.ruangan.idRuangan) {
          const data = {
            guid_aset: props.propsModal.register,
            kolok: g.$cookies.get('kolok') || props.propsModal.kolok,
            lantai: formRuangan.value.lantai,
            jenis_ruangan_id: formRuangan.value.jenisRuangan.value,
            nama_ruangan: formRuangan.value.namaRuangan,
            ruangan_id: props.propsModal.ruangan.idRuangan,
          }

          const result = await apiRuangan.putRuangan(g, data)
          if (result.isSuccess) {
            showModal.value = false
            if (props.propsModal.inputLantai) props.propsModal.inputLantai()
          }
          formRuangan.value.isSubmit = false
        } else {
          const data = {
            guid_aset: props.propsModal.register,
            kolok: g.$cookies.get('kolok') || props.propsModal.kolok,
            lantai: formRuangan.value.lantai,
            jenis_ruangan_id: formRuangan.value.jenisRuangan.value,
            nama_ruangan: formRuangan.value.namaRuangan,
          }

          const result = await apiRuangan.postRuangan(g, data)
          if (result.isSuccess) {
            props.propsModal.inputLantai()
            formRuangan.value = {
              ...formRuangan.value,
              jenisRuangan: defaultValue,
              namaRuangan: '',
              isSubmit: false,
            }
          } else formRuangan.value.isSubmit = false
        }
      } catch (err) {
        formRuangan.value.isSubmit = false
      }
    }

    return {
      showModal, formRuangan, v$, validateState, options, submitForm,
    }
  },
  directives: { Ripple },
  components: { vSelect },
  props: {
    propsModal: propsObject,
  },
}
</script>
